import { UPDATE_SM_INIT, UPDATE_SM_DONE, UPDATE_SM_FAILED } from '../../common/actions';
import { HiverAxios, unsavedChanges, showMessage, sendTrackingEvent } from 'h-commons';
import { fetchDashboardDetails } from '../../../dashboard/actions';
// import { showMessage } from '../../../messageStrip/actions';
import { reset } from 'redux-form';
const SM_ROOT = '/gx/api/sm';
/**
 * @param  {(number|string)} smid   - Shared Mailbox ID
 * @param  {string}          email  - alias email address
 * @param  {boolean}         isTest - for unit testing
 */
const postAliasAction = (smid, email, isTest) => (dispatch) => {
    dispatch({
        type: UPDATE_SM_INIT,
        payload: 'postAliasAction'
    });
    return HiverAxios({
        url: `${SM_ROOT}/${smid}/alias/${email}`,
        type: 'POST',
        params: {},
        callback: (response) => {
            const success = response.data.status === 'success';
            dispatch(unsavedChanges(false));
            dispatch(reset('newAliasForm'));
            if (success) {
                dispatch(fetchDashboardDetails());
                showMessage({ message: `Email address added`, type: 'success' });
                sendTrackingEvent('addedAlias');
                dispatch({
                    type: UPDATE_SM_DONE,
                    payload: response.data.sm
                });
            } else {
                showMessage({ message: response.data.message, type: 'error' });
                dispatch({
                    type: UPDATE_SM_FAILED
                });
            }
        },
        onfail: (err) => {
            const message = err.response && err.response.data && err.response.data.message
                ? err.response.data.message : `Failed to add alias ${email}`;
            showMessage({ message, type: 'error' });
            dispatch({
                type: UPDATE_SM_FAILED
            });
        }
    }, isTest);
}
export {
    postAliasAction
}